import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { isPlatformBrowser, Location } from '@angular/common';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  creditCards = null;
  creditCardsNotFound: boolean = false;
  featureTags = {};
  selectedPaymentMethod:any;
  defaultCardNo : number;
  userDetails={};
  userDetailsForStoreCredit={};
  paymentCashOnDelivery: any;

  constructor(
    private apiService: ApiService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private router: Router,
    private subscription: SubscriptionService,
    public sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {    
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    if (!!this.featureTags && this.featureTags['ftag_to_set_default_credit_card']) {
      this.route.queryParams.subscribe(params => {                 
        this.defaultCardNo = params.id;
        if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
          this.paymentCashOnDelivery = this.route.snapshot['data']['store']['response']['data']['payment_method_details'][0];
          this.userDetails = this.route.snapshot['data']['userDetails']['response']['data']['users'];
          this.selectedPaymentMethod = this.userDetails['preferred_payment_method'];
        }
      });
      if (this.defaultCardNo){
        this.setDefaultCreditCard(this.defaultCardNo);
        const newUrl = `/account/payment`;
        this.location.replaceState(newUrl);  // Change the URL in the browser's address bar 
      }else {
        this.getCreditCardLists();
      }
    } else {
    this.getCreditCardLists();
    }
    if (!!this.featureTags && this.featureTags['ftag_pay_with_store_credit_design_feature_in_sf']) {
      if (this.route.snapshot['data']['userDetails'] && this.route.snapshot['data']['userDetails']['response']['status'] === 1) {
        this.userDetailsForStoreCredit = this.route.snapshot['data']['userDetails']['response']['data']['users'];
      }
    }
  }

  /***********get credit card list**************/
  getCreditCardLists() {
    this.creditCardsNotFound = false;
    this.apiService.getCreditCardList().subscribe(data => {
      if(data['response']['status'] === 1) {
        this.creditCards = data['response']['data']['credit_cards'];
      }else {
        this.creditCardsNotFound = true;
        if(!!this.featureTags && this.featureTags['ftag_sf_card_expiry']){
          this.sharedDataService.triggerCreditCard$.next(true);}
      }
    }, err => {
      console.log(err)
    })
  }
  /********************end*********************/

  setDefaultCreditCard(cardId: number) {
    this.apiService.setDefaultCreditCard(cardId).subscribe(data => {
      if(data['response']['status'] === 0) {
        this.notification.error(data['response'].message, 5000)
      }else if(data['response']['status'] === 1) {
        this.getCreditCardLists();
        this.notification.success('Default credit card set successfully', 5000);
        if(!!this.featureTags && this.featureTags['ftag_sf_card_expiry']){
        this.sharedDataService.triggerCreditCard$.next(true);}
      }else if(data['response']['status'] === 3) {
        let errorMsg = data['response'].data.message['card_id'];
        this.notification.warning('Validation error -- '+errorMsg[0], 5000)
      }
    }, err => {
      console.log(err)
    })
  }

  editCreditCard(cardData: object) {
    this.subscription.behSubjectNext({
      msg: "Edit Credit Card",
      creditCard: cardData
    });
    this.router.navigate(['/account/payment/edit-credit-card']);
  }

  deleteCreditCard(cardId: number, defaultCard: any) {
    if(defaultCard === true) {
      return this.notification.warning('This is your DEFAULT payment option!.Please set other card as DEFAULT before deleting.', 5000);
    }
    const dialogRef = this.dialog.open(PopupComponent, {
      data : {cardNumber: cardId ,msg : 'delete credit card'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result === 'delete') {
        this.apiService.deleteCreditCard(cardId).subscribe(data => {
          if(data['response']['status'] === 0) {
            this.notification.error(data['response'].message, 5000)
          }else if(data['response']['status'] === 1) {
            this.getCreditCardLists();
            this.notification.success('Successfully deleted credit card', 5000)
          }else if(data['response']['status'] === 3) {
            let errorMsg = data['response'].data.message['card_id'];
            this.notification.warning('Validation error -- '+errorMsg[0], 5000)
          }
        }, err => {
          console.log(err)
        })
      }
    });
  }
  selectPaymentMethod(event:any) {
    console.log(event);
    let paymentMethod = {
      preferred_payment_method: event.value
    };
    this.apiService.setPaymentPreferrance(paymentMethod).subscribe(data => {
      console.log(data); 
      if (data['response']['status'] === 1) {
        this.notification.success(data['response']['message'], 5000);
        this.getUserDetails()
      }
      
    });
    
    // this.selectedPaymentMethod = method;
  }
  getUserDetails() {
    if(isPlatformBrowser(this.platformId)){
    this.apiService.getAutheticatedUserDetails().subscribe(data => {
      if (data['response']['status'] === 1) {
        this.userDetails = data['response']['data']['users'];
        this.selectedPaymentMethod = this.userDetails['preferred_payment_method'];
        console.log(this.selectedPaymentMethod);
      }
    }, err => { })
  }

  }

}
